import { useEffect, useState } from "react";
import { api, errText } from "@/lib/api";
import { fint } from "@/lib/ui";

const when = s => s ? new Date(s).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true }).replace(/\b(am|pm)\b/i, m => m.toUpperCase()) + " IST" : "—";
const cell = v => v === null || v === undefined ? "" : typeof v === "object" ? JSON.stringify(v) : String(v);

const Empty = () => (
  <div className="card span-12" data-testid="research-empty">
    <p className="empty" style={{ margin: 0 }}>No data yet: this will fill automatically once the live database is connected.</p>
  </div>
);

function DataTable({ d }) {
  return (
    <div className="card span-12" data-testid="research-card">
      <div className="card-head"><div><h2>ResearchStudies</h2>
        <p className="sub"><span className="num" data-testid="research-row-count">{fint(d.row_count)}</span> rows · {d.columns.length} columns · Last fetched <b data-testid="research-fetched-at">{when(d.fetched_at)}</b> · Source <span className="num">{d.source_schema}."{d.source_table}"</span></p></div></div>
      <div className="tbl-wrap raw-wrap"><table className="raw-tbl" data-testid="research-table">
        <thead><tr>{d.columns.map((c, i) => <th key={i}>{c}</th>)}</tr></thead>
        <tbody>{d.rows.length ? d.rows.map((r, i) => <tr key={i}>{r.map((v, j) => <td key={j}>{cell(v)}</td>)}</tr>)
          : <tr><td colSpan={Math.max(1, d.columns.length)} className="empty">The table is empty.</td></tr>}</tbody>
      </table></div>
    </div>
  );
}

export default function ResearchStudies({ onExpired }) {
  const [d, setD] = useState(null), [err, setErr] = useState("");
  useEffect(() => {
    api("/api/admin/research-studies").then(async r => {
      if (r.status === 401) { onExpired(); return; }
      const j = await r.json();
      if (!r.ok) setErr(errText(j)); else setD(j);
    }).catch(() => setErr("Network error. Please reload the page."));
  }, [onExpired]);
  return (
    <div className="grid" data-testid="research-studies-page">
      {err ? <div className="card span-12"><div className="adm-msg err" role="alert" data-testid="research-error">{err}</div></div>
        : !d ? <div className="card span-12"><p className="empty" style={{ margin: 0 }}>Loading…</p></div>
          : d.status === "no_data" ? <Empty /> : <DataTable d={d} />}
    </div>
  );
}
